import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/university/university_01.png';
import icn_02 from '../../assets/img/landingPage/university/university_02.png';
import icn_03 from '../../assets/img/landingPage/designer/icn_Desginer-02.png';
import icn_04 from '../../assets/img/landingPage/arcademy/icn_arcademy-03.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4';
import logo from '../../assets/img/logos/AVAP_University_negativo.svg'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/university/University_dashboard.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const University = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'A global academic network',
            text: "Partnering with top universities and training institutions worldwide, AVAP University integrates its courses into academic programs, co-creates certifications, and builds a strong professional community with industry relevance at its core.",
            altDescription: "Partnering with top universities and training institutions worldwide, AVAP University integrates its courses into academic programs, co-creates certifications, and builds a strong professional community with industry relevance at its core.",
            image: icn_01,
        },
        Key_Feature_02: {
            title: "Beyond education: Building careers, empowering ecosystems",
            text: "More than just a learning platform, AVAP University drives workforce development, partner enablement, and professional growth, fueling opportunities across the entire AVAP ecosystem.",
            altDescription: "More than just a learning platform, AVAP University drives workforce development, partner enablement, and professional growth, fueling opportunities across the entire AVAP ecosystem.",
            image: icn_02,
        },
        Key_Feature_03: {
            title: 'Flexible learning for busy professionals',
            text: "Our modular learning paths let you tailor your education journey, whether you’re beginning with AVAP fundamentals or advancing into specialized topics like cloud-native microservices or API lifecycle management.",
            altDescription: 'Our modular learning paths let you tailor your education journey, whether you’re beginning with AVAP fundamentals or advancing into specialized topics like cloud-native microservices or API lifecycle management.',
            image: icn_03,
        },
        Key_Feature_04: {
            title: 'Certifications that count',
            text: 
            "Gain industry-recognized credentials that validate your skills, boost career opportunities, and give you a competitive edge in the fast-changing tech landscape.",
            altDescription: 'Gain industry-recognized credentials that validate your skills, boost career opportunities, and give you a competitive edge in the fast-changing tech landscape.',
            image: icn_04,
        },
    }
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" 
                className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Cloud"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Professional Education for a Smarter Digital Future</h1>
                    <p className="fl-subtitle pb-4 fl-txt-container-s">
                    Empowering professionals to lead the next wave of digital transformation.
                    </p>
                </section>

                {/* Powerful API Platform */}
                <section className="text-center pb-8">
                    <img
                        src={dashboard}
                        alt="AVAP Cloud illustration displaying API Manager Service components including Devs & Organizations, Managed APIs, IAM, credentials, API Projects, API Catalog, Dev Portal, Gateway Manager, BRUNIX AI, and AI analytics."
                        className="img-fluid mt-4"
                        style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                    />
                    <h2 className="fl-title m-4 pt-8">AVAP University: Where innovation meets education.</h2>
                    {/*<p className="fl-subtitle-xs mb-3">
                        Manage the entire API lifecycle in a SaaS model from <br /> design to testing and deployment.
                    </p>*/}
                    <p className="fl-text fl-txt-container-s">
                    AVAP University is the dedicated learning hub within the AVAP ecosystem, built for professionals ready to certify, enhance, and master their expertise in the AVAP Framework and the technologies shaping tomorrow’s digital enterprises.
                    </p>
                    <p className="fl-text fl-txt-container-s">
                    With programs designed and delivered in collaboration with leading universities and training partners, AVAP University bridges theory with real-world practice. From the fundamentals of AVAP programming to automation, API integration, microservices, and hybrid infrastructure, our curriculum equips professionals with the knowledge to design, build, and lead future-ready digital solutions.
                    </p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                </section>

                

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                          
                            <p className="fl-title-center m-0">Key Features</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-9">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*Boton Contact Us*/}  
                            <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                        </section>
                    </div>
                </div>

                <br />
                <br />
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default University;
